export const DEFAULT_PRIORITY = {
  status: 100,
  prioridade: 95,
  urgencia: 95,
  responsible: 90,
  responsavel: 90,
  assignedto: 90,
  assigneduserid: 90,
  collaboratorid: 88,
  collaboratorids: 88,
  scheduleddate: 85,
  dataagendada: 85,
  completedat: 82,
  concludedat: 82,
  duedate: 80,
  paid: 80,
  notafiscal: 92,
  notafiscalnumero: 92,
  invoicenumber: 92,
  invoicedate: 91,
  invoicevalue: 91,
  nfpendente: 93,
};

export const COLLECTION_PRIORITY = {
  ocorrencias: { prioridade: 100, status: 98, scheduledto: 95, scheduleddate: 95, observacoesfinais: 70, description: 65 },
  services: { prioridade: 100, status: 99, collaboratorids: 96, scheduleddate: 95, observations: 72 },
  outsourcedservices: { prioridade: 100, status: 99, notafiscal: 98, notafiscalnumero: 98, invoicenumber: 98, nfpendente: 97, providerid: 94, collaboratorids: 92, scheduleddate: 90 },
  employees: { status: 99, role: 97, primaryfarmid: 96, sharedfarms: 96 },
};

export function normalizeFieldName(field) {
  return String(field || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
}

export function fieldPriority(collection, field) {
  const normalized = normalizeFieldName(field);
  const coll = COLLECTION_PRIORITY[normalizeFieldName(collection)] || {};
  if (normalized in coll) return coll[normalized];
  if (normalized in DEFAULT_PRIORITY) return DEFAULT_PRIORITY[normalized];
  return 50;
}

export function classifyConflictSeverity(collection, fields = []) {
  const priorities = (Array.isArray(fields) ? fields : []).map((field) => fieldPriority(collection, field));
  const max = priorities.length ? Math.max(...priorities) : 0;
  if (max >= 95) return 'critical';
  if (max >= 85) return 'high';
  if (max >= 70) return 'medium';
  return 'low';
}
